<!--
 * @Author: xiaokun
 * @Date: 2020-04-10 19:40:36
 * @LastEditors: xiaokun
 * @LastEditTime: 2020-06-12 15:56:35
 * @Description:新增/编辑 基本信息组件
 -->
<template>
  <div class="examination-basic-info">
    <mk-form
      ref="basicInfoForm"
      :model="basicInfoData"
      label-width="81px"
      :rules="rules"
    >
      <!-- 考试名称 -->
      <mk-form-item
        label="考试名称:"
        prop="name"
      >
        <mk-input
          v-model.trim="basicInfoData.name"
          placeholder="请输入考试名称"
          maxlength="20"
          show-word-limit
          width="370"
        />
      </mk-form-item>
    </mk-form>
    <mk-form
      :model="basicInfoData"
      label-width="80px"
    >
      <!-- 考试标签 -->
      <mk-form-item
        label="考试标签:"
      >
        <!-- 标签多选组件 -->
        <tag-select
          :key="tagsKey"
          v-model="basicInfoData.tags"
          :tip="false"
          :width="370"
          :max-num="0"
          @change="onChangeGetTagIdList"
        />
      </mk-form-item>
    </mk-form>
    <mk-form
      :model="basicInfoData"
      label-width="80px"
    >
      <!-- 答卷时长 -->
      <mk-form-item
        label="答卷时长:"
        prop="score"
      >
        <div>
          <!-- v-model="basicInfoData.time.minutes" -->
          <!-- v-if="basicInfoData.time.type===1" -->
          <!-- 指定时长 -->
          <mk-radio
            v-model="basicInfoData.time.type"
            :label="1"
          >
            <span>
              <mk-input-number
                v-model="basicInfoData.time.minutes"
                :disabled="basicInfoData.time.type===2"
                :width="50"
                :min="1"
                :controls="false"
              />
              分钟
            </span>
          </mk-radio>
          <mk-radio
            v-model="basicInfoData.time.type"
            :label="2"
          >
            不限时长
          </mk-radio>
        </div>
      </mk-form-item>
      <!-- 考试说明 -->
      <mk-form-item
        label="考试说明:"
        prop="description"
      >
        <mk-input
          v-model.trim="basicInfoData.description"
          placeholder="请输入考试说明"
          class="examination-desc-input"
          resize="none"
          type="textarea"
          maxlength="50"
          show-word-limit
          width="370"
        />
      </mk-form-item>
    </mk-form>
  </div>
</template>
<script>
import tagSelect from '@components/tag-select'
export default {
  name: 'ExaminationBasicInfo',
  components: { tagSelect },
  props: {
    // 是否处于编辑状态
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      // tags: [],
      basicInfoData: {
        name: '',
        description: '',
        // 1指定时间 2不限时长 为1时minutes必填
        time: {
          minutes: 60,
          type: 1
        },
        tags: []
      },
      tagsKey: '',
      rules: {
        name: [{
          required: true, message: '考试名称不能为空', trigger: 'blur'
        }]
      }
    }
  },
  created () {},
  mounted () { },
  methods: {
    // 编辑时 父级数据回显
    setData (data) {
      this.basicInfoData = this._.cloneDeep(data.paperInfo)

      this.basicInfoData.tags = data.showTags.map(item => {
        return item.id
      })

      // 更新key保证tags回显正确
      this.tagsKey = new Date().getTime()
    },
    returnData () {
      return this.basicInfoData
    },
    // 选择标签
    onChangeGetTagIdList (val) {
      this.basicInfoData.tags = val
    }
  }
}
</script>
<style lang='scss' scoped>
.examination-basic-info {
  background: #fff;
  padding-left: 45px;

  .examination-desc-input {
    height: 100px !important;

    /deep/ .el-input__count {
      line-height: 1;
    }
  }
}
</style>
